import * as React from "react";
const IconCenterAlign5 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M14.1 5h35.8c.6 0 1-.4 1-1s-.4-1-1-1H14.1c-.6 0-1 .4-1 1s.5 1 1 1" />
    <path d="M61 3.9c-.6 0-1 .4-1 1V31H48.7v-7.9c0-2.9-2.4-5.3-5.3-5.3h-1.9c-3 0-5.3 2.4-5.3 5.3V31H28V19.2c0-3-2.4-5.4-5.3-5.4h-1.9c-3 0-5.4 2.4-5.4 5.4V31H4V4.9c0-.6-.4-1-1-1s-1 .4-1 1v50.8c0 3 2.4 5.3 5.4 5.3h49.3c3 0 5.3-2.4 5.3-5.3V4.9c0-.5-.4-1-1-1M38.1 23.1c0-1.8 1.5-3.3 3.3-3.3h1.9c1.8 0 3.3 1.5 3.3 3.3v17.8c0 1.8-1.5 3.4-3.3 3.4h-1.9c-1.8 0-3.3-1.5-3.3-3.4zm-17.5-7.3h1.9c1.8 0 3.3 1.5 3.3 3.4v25.6c0 1.8-1.5 3.3-3.3 3.3h-1.9c-1.8 0-3.4-1.5-3.4-3.3V19.2c.1-1.9 1.6-3.4 3.4-3.4M56.7 59H7.4C5.5 59 4 57.5 4 55.7V33h11.3v11.8c0 3 2.4 5.3 5.4 5.3h1.9c2.9 0 5.3-2.4 5.3-5.3V33h8.2v7.9c0 3 2.4 5.4 5.3 5.4h1.9c3 0 5.3-2.4 5.3-5.4V33H60v22.7c0 1.8-1.5 3.3-3.3 3.3" />
  </svg>
);
export default IconCenterAlign5;
